<script setup lang="ts">
import FooterItem from '@fondof-ui/components/footer/FooterItem.vue'
import FooterLanguage from '@fondof-ui/components/footer/FooterLanguage.vue'
import type { LocaleLinkItem } from '@fondof-ui/types'
import FooterHeadline from '@satch-ui/components/footer/FooterHeadline.vue'
import { t } from '@satch-ui/translations/translations'

const props = defineProps<{ locales: LocaleLinkItem[] }>()
</script>
<template>
  <div class="row-start-2 md:col-start-[first-col] md:row-start-[third-row]">
    <FooterItem disabled>
      <template #headline="{ disabled }">
        <FooterHeadline
          :headline="t('footer.languageTitle')"
          variant="primary"
          :disabled="disabled"
        />
      </template>
      <template #content>
        <div class="flex space-x-2">
          <FooterLanguage
            v-for="locale in props.locales"
            :key="locale.code"
            :locale="locale"
            :is-last="locale === props.locales[props.locales.length - 1]"
            class="text-primary"
          />
        </div>
      </template>
    </FooterItem>
  </div>
</template>
